import { createElementBlock as t, openBlock as n, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function c(r, e) {
  return n(), t("svg", o, e[0] || (e[0] = [
    l("path", {
      fill: "#4285F4",
      d: "M22.533 12.248c0-.725-.065-1.412-.175-2.081H12V14.3h5.93c-.265 1.357-1.044 2.502-2.2 3.281v2.75h3.54c2.07-1.915 3.262-4.739 3.262-8.084"
    }, null, -1),
    l("path", {
      fill: "#34A853",
      d: "M12 23c2.97 0 5.454-.99 7.27-2.668l-3.54-2.75c-.99.66-2.245 1.064-3.73 1.064-2.87 0-5.298-1.934-6.17-4.547H2.183v2.833C3.988 20.525 7.701 23 12 23"
    }, null, -1),
    l("path", {
      fill: "#FBBC05",
      d: "M5.83 14.1a6.4 6.4 0 0 1-.348-2.1c0-.733.129-1.44.349-2.1V7.069H2.182a10.87 10.87 0 0 0 0 9.864z"
    }, null, -1),
    l("path", {
      fill: "#EA4335",
      d: "M12 5.354c1.622 0 3.07.56 4.217 1.65l3.135-3.135C17.454 2.091 14.97 1 12 1 7.7 1 3.988 3.475 2.182 7.068l3.649 2.833C6.7 7.288 9.13 5.354 12 5.354"
    }, null, -1)
  ]));
}
const d = { render: c };
export {
  d as default,
  c as render
};
//# sourceMappingURL=ic_brand_google-D4o_usNa.js.map
